/* 整期还款信息接口 */

import axios from 'axios';
export default {
  getWholePeriodRepayInfo (params) { // 获取整期还款信息接口
    return axios.get('/loanform/finance/loanItemFinanceRepay/getWholePeriodRepayInfo.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId,
        frontItemApplyState: params.frontItemApplyState
      }
    });
  },

  wholePeriodPayConfirm (params) { // 整期还款,确认还款接口
    return axios.get('/loanform/finance/loanItemFinanceReceipt/wholePeriodPayConfirm.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId
      }
    });
  }

};



// WEBPACK FOOTER //
// ./src/api/personalCenter/wholeRepay.js